// $('.invest__option__item_caption').on('click', function () {
//     const $item = $(this).closest('.invest__option__item');
//     const $content = $item.find('.invest__option__item_content');

//     $('.invest__option__item_content').not($content).slideUp();

//     $content.slideToggle();
// });